import styled from 'styled-components';
import { Chip } from '@workboard/wobo-ui';
import React, { FC, useCallback, useMemo, useState } from 'react';

import { useAxios } from '../../hooks/useAxios';
import { testWorkstreamColumnChip } from './testIds';
import { AutocompleteChip } from '../../form/AutocompleteChip';

interface IProps {
  workstreamId: string;
  value?: string;
  label?: string;
  loading?: boolean;
  isDisabled?: boolean;
  onChange?: (e, obj) => void;
}

interface Column {
  id: string;
  title: string;
}

const ChipWrapper = styled(Chip)`
  .MuiChip-icon {
    margin-left: 4px !important;
  }
`;

export const WorkstreamColumnField: FC<IProps> = ({
  value,
  label,
  loading,
  isDisabled,
  workstreamId,
  onChange,
}) => {
  const [{ data: streamColumns }] = useAxios({
    url: 'activity/getColumnList',
    method: 'GET',
    params: {
      tagId: workstreamId,
      json: true,
    },
  });
  const [filter, setFilter] = useState<string>('');
  const options = useMemo(
    () =>
      streamColumns
        ? Object.values(streamColumns)
            .filter((c: Column) => Boolean(c.id))
            .filter((c: Column) =>
              c.title.toLowerCase().includes(filter.toLowerCase())
            )
            .map((c: Column) => ({
              label: c.title,
              id: c.id,
            }))
        : [],
    [streamColumns, filter]
  );
  const handleChange = useCallback(
    (e, obj) => {
      e.target = obj;
      onChange?.(e, obj);
    },
    [onChange]
  );


  // @ts-expect-error LegacyRef issue
  const ChipTemplate: React.ComponentProps<typeof AutocompleteChip>['chipTemplate'] = useMemo(() =>
    React.forwardRef(
      ({ value: chipValue, onClick }, ref) => (
        <ChipWrapper
          ref={ref}
          size="large"
          type="input"
          onClick={onClick}
          disabled={isDisabled}
          label={chipValue?.label ?? 'Column'}
          iconName="ViewColumnOutlined"
        />
    )), [isDisabled]);

  return (
    <AutocompleteChip
      loading={loading}
      label={label}
      onInputChange={(e, text) => {
        if (e) {
          setFilter(text);
        }
      }}
      onChange={handleChange}
      data-testid={testWorkstreamColumnChip}
      chipTemplate={ChipTemplate}
      options={options}
      getOptionSelected={(option, val) => option.id === val?.id}
      value={options.find((u) => u.id === value) ?? null}
    />
  );
};
